<template>
  <div class=" navbar-horizontal-layout ">

    <vs-navbar v-model="activeItem" class="vx-navbar-layout center-element">


      <div slot="title" class="center-element" >
        <vs-navbar-title class="line-h-0 my-1">
          <a href="https://verificamex.com/" >
            <img :src="logo" width="175" class="center-element"  alt="Verificamex" ref="logo"/>
          </a>
        </vs-navbar-title>
      </div>

    </vs-navbar>
  </div>
</template>

<script>
import Logo from "@/layouts/components/LogoFull.vue";

export default {
  components: {
    Logo,
  },
  data: () => ({
    activeItem: 0,
    logo: require('@/assets/images/logo/logo-full.svg')
  }),
  beforeMount() {
    let uuid = this.$route.params.uuid
    if (!uuid) {
      return
    }
    this.$store.dispatch("document/getDocumentFromSignature", {uuid: uuid})
      .then(
        document => {
          let container = document.relationships.container;
          this.logo = "data:image/png;base64," + container.data[0].logo
        }
      )
  }
}
</script>
<style scoped>
.vs-navbar--btn-responsive{
  display: none;
}
.center-element{
  display: block!important;
  margin: 0 auto!important;
}
</style>
